import React from "react";
import { Labeled, TextField } from "react-admin";
import { JsonField } from "react-admin-json-view";

export const defaultReactJsonOptions = {
	name: null,
	collapsed: false,
	enableClipboard: false,
	displayDataTypes: false,
	style: {
		padding: "8px 0 4px",
	},
};

export const JsonTextField = ({
	label,
	jsonString = true,
	reactJsonOptions = defaultReactJsonOptions,
	...props
}) => {
	const data = props?.record?.[props?.source];

	const isValidJson = (str) => {
		if (typeof str !== "string") return false;
		try {
			JSON.parse(str);
			return true;
		} catch {
			return false;
		}
	};

	const isJson = typeof data === "object" || isValidJson(data);

	return (
		<Labeled label={label} source={props.source}>
			{isJson ? (
				<JsonField {...props} jsonString={jsonString} reactJsonOptions={reactJsonOptions} />
			) : (
				<TextField source={props.source} record={props.record} />
			)}
		</Labeled>
	);
};
